//-- React Standard
import React, { Component } from "react";
import { connect } from 'react-redux';
import Moment from 'moment';
import config from '../../config';
//-- Custom
import TopBar from "../Common/TopBar/TopBar";
import SideBar from "../Common/SideBar/SideBar";
import Footer from "../Common/Footer/Footer";
import { apiConstants } from '../../_constants/api.constants';
import Pagination from "../Common/Pagination/Pagination";
import PageLimit from "../Common/PageLimit/PageLimit";
import DeletePopup from "../Common/Popup/DeletePopup";
import ViewPopup from "../Common/Popup/ViewPopup";
import { orderActions, userActions } from "../../_actions";
import { commonFunctions } from "../Common/common";


class Orders extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sort: {
                sortKey: null,
                direction: 'desc',
            },
            totalPage: '',
            totalDataCount: '',
            currentPage: 1,
            orderData: [],
            perPage: 10,


            getCouponList: [],
            viewOpen: false,
            editOpen: false,
            deleteOpen: false,
            advertisments: {
                title: '',
                advertisment_image: '',
            },
            popupType: '',
            addButton: false,
            shopKeeperAdd: false,
            shopKeeperData: []
        };
    }
    
    /*
    * componentDidMount - Initially it will call and get the orders data
    */
    componentDidMount() {
        this.getOrdersConditionally(this.state.perPage, 1);
    }

    //get orders common
    getOrdersConditionally = (perpage, pageNo) => {
        const { dispatch } = this.props;
        let userData = JSON.parse(sessionStorage.getItem('user'));
        let postData = {};
        postData.page = pageNo;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = perpage;
        if (userData.role_type[0] == 'shopkeeper') {
            postData.shopkeeperId = userData._id;
            postData.merchantShopId = userData.merchantShopId;
        }
        dispatch(orderActions.getAllOrders(apiConstants.GET_ALL_ORDERS, postData));
    }


    /*
    * componentWillReceiveProps - Whenever Props change, it will call and store data
    * update the state values with new props values, this method will get called whenever any change happens to props values
    */
    componentWillReceiveProps(props) {
        if (props.getAllOrders) {
            if (props.getAllOrders.orderList !== undefined &&
                props.getAllOrders.orderList.data !== undefined &&
                props.getAllOrders.orderList.data.allData !== undefined) {

                let orders = props.getAllOrders.orderList.data;
                this.setState({
                    orderData: orders.allData,
                    totalPage: orders.pagination.totalPages,
                    totalDataCount: orders.pagination.totalCount
                })
            }
        }
    }


    /*
    *   Pagination function: It will call from pagination section and change data in table
    */
    makeHttpRequestWithPage = (pageNumber) => {
        this.setState({
            currentPage: pageNumber
        });

        this.getOrdersConditionally(this.state.perPage, pageNumber);
    }



    changeTableData = (e) => {
        this.getOrdersConditionally(parseInt(e.target.value), 1);
        this.setState({ perPage: parseInt(e.target.value) });
    }
    /*
    * searchOrders - User can search data from the database and it will appear
    */
    searchOrders(keyword, perpage, pageNo) {
        const { dispatch } = this.props;
        let userData = JSON.parse(sessionStorage.getItem('user'));

        let postData = {};
        postData.page = pageNo;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = perpage;
        if (userData.role_type[0] == 'shopkeeper') { postData.shopkeeperId = userData._id; }

        dispatch(orderActions.getAllOrders(apiConstants.GET_ALL_ORDERS, postData));


        if (keyword.target.value !== '') {
            postData.search = keyword.target.value;
            dispatch(orderActions.getAllOrders(apiConstants.SEARCH_ORDER, postData));
        } else {
            dispatch(orderActions.getAllOrders(apiConstants.GET_ALL_ORDERS, postData));
        }
    }

    //-- Popup Handler
    /*
    *   Modal open-close functionality
    */
    // popupOpen = (advertisments, type, btnClick) => {
    //     //-- check add button clicked
    //     if (btnClick === 'addButton') {
    //         this.setState({ addButton: true });
    //         this.setState({ popupType: 'AddShopkeeper' })
    //     }
    //     //this.setState({ advertisments, [type]: true })
    // };

    // EditPopupOpen = (couponData, type) => {
    //     this.setState({
    //         data: couponData,
    //         popupType: 'EditCoupon',
    //         addButton: true
    //     });

    //     this.setState({ [type]: true })
    // }


    // DeletePopupOpen = (couponId, type) => {
    //     this.setState({
    //         deleteId: couponId
    //     });

    //     this.setState({ [type]: true })
    // }
    /*
    *   Close the popup
    */
    popupClose = (type) => {
        this.setState({
            advertisments: {
                title: '',
                type: '',
                advertisment_image: '',
            },
            addButton: false,
            [type]: false
        });
    };

    /*
    *   We are handling validation from this function
    */
    // handleValidation(data) {
    //     const { siteConstants } = this.props.language;

    //     let fields = data.defaultData;
    //     let errors = {};
    //     let formIsValid = true;
    //     //Name
    //     if ((fields["title"] == '')) {
    //         formIsValid = false;
    //         if (fields["title"] == '') {
    //             errors["title"] = siteConstants.ERR_CAN_NOT_BLANK;
    //         }
    //     }

    //     if (!fields["title"]) {
    //         if (!fields["title"].match(/^[a-zA-Z]+$/)) {
    //             formIsValid = false;
    //             errors["title"] = siteConstants.ERR_ONLY_LETTERS;
    //         }
    //     }
    //     return ({ errors, formIsValid });
    // }


    deleteCoupon = (couponId) => {
        let postData = {};
        postData.page = this.state.currentPage;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = this.state.perPage;

        let obj = {};
        obj.id = couponId;
        this.props.dispatch(userActions.deleteCoupon(apiConstants.DELETE_COUPON, obj, apiConstants.GET_COUPOUN, postData));
        this.popupClose('deleteOpen');
    }


    // openAddShopKeeper = () => {
    //     this.setState({ shopKeeperAdd: !this.state.shopKeeperAdd })
    // }

    // handleClose = () => {
    //     this.setState({ shopKeeperAdd: !this.state.shopKeeperAdd })
    // };

    viewOrderDetails = (orderId) => {
        const { history } = this.props;
        let url = '/order-details/' + orderId;
        history.push(url);
    }

    //-- Main function
    render() {
        const { siteConstants } = this.props.language;
        return (
            <div id="wrapper">

                <SideBar />

                <div id="content-wrapper" className="d-flex flex-column">
                    {/* <!-- Main Content --> */}
                    <div id="content">

                        <TopBar />
                        <nav className="" aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <a href="/dashboard">{siteConstants.GEN_DASHBOARD}</a>
                                </li>
                                <li className="active breadcrumb-item" aria-current="page">
                                    {siteConstants.MENU_ORDERS}
                                </li>
                            </ol>
                        </nav>

                        {/* <!-- Begin Page Content --> */}
                        <div className="container-fluid">

                            <div className="d-sm-flex align-items-center justify-content-between mb-4 mt-2">
                                <h1 className="h3 mb-0 text-gray-800 fontBold">{siteConstants.MENU_ORDERS}</h1>
                                <a href="/add-shopkeeper"
                                //onClick={() => this.openAddShopKeeper()}
                                >
                                    {/*<span className="text">
                                        <button className="btn btn-primary">{siteConstants.BTN_ADD}</button>
                                    </span>*/}
                                </a>

                            </div>


                            <div className="card shadow mb-4">
                                <div className="card-body">
                                    <div className="table-responsive">
                                        {/* <div className="row mb-4" style={{borderBottom: '1px solid #858796'}}>
                                            <div className="col-md-1" style={{marginBottom: '6px'}}>
                                                <button className="btn btn-outline-secondary btn-block">{siteConstants.BTN_ADD}</button>
                                            </div>
                                            <div className="col-md-1" style={{marginBottom: '6px'}}>
                                                <button className="btn btn-outline-secondary btn-block">{siteConstants.BTN_ADD}</button>
                                                </div>
                                            <div className="col-md-1" style={{marginBottom: '6px'}}>
                                                <button className="btn btn-outline-secondary btn-block">{siteConstants.BTN_ADD}</button>
                                                </div>
                                            <div className="col-md-1" style={{marginBottom: '6px'}}>
                                                <button className="btn btn-outline-secondary btn-block">{siteConstants.BTN_ADD}</button>
                                            </div>
                                        </div> */}
                                        <div className="row">
                                            {/* Page limit drop down */}
                                            <PageLimit changeLimit={(e) => this.changeTableData(e)} />

                                            <div className="col-sm-12 col-md-6">
                                                <div id="dataTable_filter" className="dataTables_filter">
                                                    <label>
                                                        <input type="search" placeholder={siteConstants.SEARCH_ORDER_ID} className="form-control form-control-sm" aria-controls="dataTable" onChange={(e) => this.searchOrders(e, this.state.perPage, 1)} />
                                                    </label>
                                                </div>
                                            </div>
                                        </div>



                                        <table className="table table-bordered" width="100%" cellSpacing="0">
                                            <thead>
                                                <tr>
                                                    <th scope="col" width="5%">{siteConstants.GEN_NUMBER}</th>
                                                    <th scope="col" width="10%">{siteConstants.GEN_ORDER_CODE}</th>
                                                    <th scope="10%">{siteConstants.LABEL_DATE}</th>
                                                    <th scope="col">{siteConstants.LABEL_CUSTOMER}</th>
                                                    <th width="10%">{siteConstants.LABEL_ORDER_TOTAL}</th>
                                                    <th scope="col">{siteConstants.LABEL_PAYMENT}</th>
                                                    {/* <th scope="col">{siteConstants.LABEL_ORDER_FULFILLMENT}</th> */}
                                                    <th width="10%">{siteConstants.LABEL_ORDER_ITEMS}</th>
                                                    <th>{siteConstants.LABEL_STATUS}</th>
                                                    {/*<th width="10%">{siteConstants.LABEL_ACTION}</th>*/}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.orderData != undefined &&
                                                        this.state.orderData.length > 0 ?
                                                        this.state.orderData.map((thisOrder, index) => {
                                                            let shopTitle = 'NA';

                                                            if (thisOrder.shopData !== undefined) {
                                                                shopTitle = thisOrder.shopData.map((shop, index) => {
                                                                    return shop.title;
                                                                })
                                                            }
                                                            return (

                                                                <tr key={index}>
                                                                    <td scope="row">{index + 1}</td>
                                                                    <td><a
                                                                        href="javascript:void(0)"
                                                                        onClick={(e) => this.viewOrderDetails(thisOrder._id)}>
                                                                        {thisOrder.orderNumber}</a>
                                                                    </td>
                                                                    <td> {Moment(thisOrder.createdAt).format(config.FullDateFormat)}</td>
                                                                    <td>
                                                                        {thisOrder.usersData[0].firstname} {thisOrder.usersData[0].lastname}
                                                                    </td>
                                                                    <td>{thisOrder.pricepaid !== undefined ? config.currencyCode + thisOrder.pricepaid : "-"}</td>
                                                                    <td>{commonFunctions.paymentStatus(thisOrder.paymentStatus)}</td>
                                                                    {/* <td>Unfulfilled</td> */}
                                                                    <td>{thisOrder.ordersData.length !== undefined ? thisOrder.ordersData.length : 0}</td>
                                                                    <td>{commonFunctions.orderStatus(thisOrder.status, siteConstants)} </td>
                                                                    {/* <td className="tdTextCenter"> </td>*/}
                                                                </tr>
                                                            )
                                                        }) : <tr>
                                                            <td colSpan="7" className="noRecordFound">{siteConstants.GEN_NO_RECORD}</td>
                                                        </tr>
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                    {/* calling the another componenet */}
                                    <Pagination totalPage={this.state.totalPage} currentPage={this.state.currentPage} funPagination={this.makeHttpRequestWithPage} />



                                </div>
                            </div>

                        </div>
                        {/* <!-- /.container-fluid --> */}

                    </div>
                    {/* <!-- End of Main Content --> */}

                    {/* add shop keeper popup */}
                    {/* <AddShopkeeper openPopup={this.state.shopKeeperAdd} handleClose={()=>this.handleClose()}/> */}

                    <Footer />
                </div>

                {/* Start Popup -View advertisments details  */}
                <ViewPopup
                    popupType="AdvertismentsComponenet"
                    viewOpen={this.state.viewOpen}
                    advertisments={this.state.advertisments}
                    funPopupClose={this.popupClose}
                />
                {/* End Popup -View advertisments details  */}

                {/* Start Popup -Edit advertisments details  */}
                {/* <EditPopup
                 popupType={this.state.popupType}
                 userData={this.state.data}
                 currentPage={this.state.currentPage}
                 addButton={this.state.addButton}
                 editOpen={this.state.editOpen}
                 funPopupClose={this.popupClose}
                 funAdvertismentsAddUpdate={(e, data) => this.advertismentsAddUpdate(e, data)}
                 defaultData={this.state.advertisments}
                /> */}
                {/* End Popup -Edit advertisments details  */}
                {/* Delete popup */}
                <DeletePopup
                    deleteOpen={this.state.deleteOpen}
                    deleteId={this.state.deleteId}
                    funPopupClose={this.popupClose}
                    funDelete={this.deleteCoupon}
                />
            </div >
        );
    }
}


//-- Here we are adding Reducer names, so it can be get data from reducers using store
function mapStateToProps(state) {
    const { getAllOrders, getCoupounList, language } = state;
    return {
        getAllOrders,
        getCoupounList,
        language
    };
}

const connectedOrders = connect(mapStateToProps)(Orders);
export { connectedOrders as Orders };
